export const FORM_FIELD = {
  LANGUAGE_NAME: {
    name: 'name',
    label: 'Language name:',
    placeholder: 'Enter a language name',
    rules: [{ required: true, message: 'Language name is required' }],
  },
  LOCALE_NAME: {
    name: 'locale',
    label: 'Locale name:',
    placeholder: 'Enter a locale name',
    rules: [{ required: true, message: 'Locale name is required' }],
  },
  LOCALE_CODE: {
    name: 'code',
    label: 'Language code:',
    placeholder: 'Enter a language code',
    rules: [{ required: true, message: 'Language code is required' }],
  },
  TEXT_DIRECTION: {
    name: 'rightToLeft',
    label: 'Text direction:',
    placeholder: 'Enter a text direction',
    rules: [{ required: true, message: 'Text direction is required' }],
    options: [
      { value: false, label: 'Left to right' },
      // ! this value should be always true to make the radio work correctly.
      // ! because on BE we only have one value
      { value: true, label: 'Right to left' },
    ],
    serialize: (field, values) => {
      const fieldValue = values[field.name];

      if (fieldValue) return { [field.name]: true };
      return { [field.name]: false };
    },
    deserialize: (field, serverData) => {
      const fieldValue = serverData[field.name];

      if (fieldValue) return { [field.name]: true };
      return { [field.name]: false };
    },
  },
};
